import React, { Component } from 'react';
import { connect } from 'react-redux';

import { errorHandler, getContent, getErrorMessage } from '../../../util/responseUtil';
import ActionType from '../../../redux/reducer/globalActionType';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import RemarkMenu from '../../../components/MasterData/RemarkMenu';
import IconActionEditBlue from '../../../assets/icons/IconActionEditBlue';
import IconActionDeleteBlue from '../../../assets/icons/IconActionDeleteBlue';
import IconAddTransparent from '../../../assets/icons/IconAddTransparent';
import IconInformationBlue from '../../../assets/icons/IconInformationBlue';
import ButtonBorderNexcareDefault from '../../../components/Button/ButtonBorderNexcareDefault';
import ButtonNexcareDefault from '../../../components/Button/ButtonNexcareDefault';
import TableNexcare from '../../../components/Table/TableNexcare';
import API_REMARK from '../../../api/apiRemark';
import Alert from '../../../components/Alert/Alert';
import Mandatory from '../../../components/Common/Mandatory';
import MandatoryAlert from '../../../components/Common/MandatoryAlert';
import { CheckPermissionComponent } from '../../../util/permission';
import {
    MASTER_DATA_REMARK_DELETE,
    MASTER_DATA_REMARK_INSERT,
    MASTER_DATA_REMARK_UPDATE,
    MASTER_DATA_REMARK_VIEW
} from '../../../constants/menuPermissionConstant';

class KMSFeedback extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
            },
            columns: [
                {
                    title: "Remark",
                    dataIndex: "remark",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Aksi",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    width: "w-1/12",
                    render: (data) => (
                        <div className="flex items-center space-x-3">
                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_REMARK_UPDATE]} userPermission={this.props.userDetail.permissions}>
                                <div id="btnedit" className="w-6 h-6 flex justify-center items-center cursor-pointer" onClick={() => this.setState({ showEditModal: true, kmsFeedbackDataSelectedEdit: data, kmsFeedback: data.remark })}>
                                    <IconActionEditBlue />
                                </div>
                            </CheckPermissionComponent>
                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_REMARK_DELETE]} userPermission={this.props.userDetail.permissions}>
                                <div id="btndelete" className="w-6 h-6 flex justify-center items-center cursor-pointer" onClick={() => this.setState({ showConfirmDeleteAlert: true, kmsFeedbackDataSelectedDelete: data })}>
                                    <IconActionDeleteBlue />
                                </div>
                            </CheckPermissionComponent>
                        </div>
                    ),
                },
            ],
            listKmsFeedback: [],
            kmsFeedback: '',
            kmsFeedbackDataSelectedEdit: {},
            kmsFeedbackDataSelectedDelete: {},
            showWarningKmsFeedback: false,
            showPopupInfo: false,
            showAddModal: false,
            showEditModal: false,
            showConfirmAddAlert: false,
            showSuccessAddAlert: false,
            showConfirmEditAlert: false,
            showSuccessEditAlert: false,
            showConfirmDeleteAlert: false,
            showSuccessDeleteAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    handleSelectedPage = currentPage => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    current: currentPage,
                },
            },
            () => {
                this.getInitiateKmsFeedback();
                this.getListKmsFeedback(this.state.pagination.current, this.state.pagination.pageSize);
            }
        );
    };

    handleSelectedPageSize = currentPageSize => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    pageSize: currentPageSize,
                    current: 1,
                },
            },
            () => {
                this.getInitiateKmsFeedback();
                this.getListKmsFeedback(this.state.pagination.current, this.state.pagination.pageSize);
            }
        );
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    getInitiateKmsFeedback = () => {
        API_REMARK.getInitiateKmsFeedback(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        pagination: { ...this.state.pagination, total: getContent(res).count_data }
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListKmsFeedback = (current, pageSize) => {
        API_REMARK.getListKmsFeedback(current, pageSize, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        listKmsFeedback: getContent(res)
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    handleCancelButton = () => {
        this.setState({
            showAddModal: false,
            showEditModal: false,
            showWarningKmsFeedback: false,
            kmsFeedback: ''
        });
    }

    handleConfirmAddKmsFeedback = () => {
        if (!this.state.kmsFeedback) return this.setState({ showWarningKmsFeedback: true });
        this.setState({ showConfirmAddAlert: true });
    }

    handleAddKmsFeedback = () => {
        const data = {
            remark: this.state.kmsFeedback,
            category: 'KMS_Feedback'
        }

        API_REMARK.postDataRemark(data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        showAddModal: false,
                        showConfirmAddAlert: false,
                        showSuccessAddAlert: true,
                        kmsFeedback: ''
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    showConfirmAddAlert: false,
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleSuccessAddKmsFeedback = () => {
        this.setState({
            showSuccessAddAlert: false,
            pagination: {
                ...this.state.pagination,
                current: 1,
                pageSize: 10,
            },
        }, () => {
            this.getInitiateKmsFeedback();
            this.getListKmsFeedback(this.state.pagination.current, this.state.pagination.pageSize);
        })
    }

    handleConfirmEditKmsFeedback = () => {
        if (!this.state.kmsFeedback) return this.setState({ showWarningKmsFeedback: true });
        this.setState({ showConfirmEditAlert: true });
    }

    handleEditKmsFeedback = () => {
        const kmsFeedbackId = this.state.kmsFeedbackDataSelectedEdit.id;
        const data = {
            remark: this.state.kmsFeedback,
            description: this.state.kmsFeedbackDataSelectedEdit.description,
            category: 'KMS_Feedback',
            category_id: this.state.kmsFeedbackDataSelectedEdit.category_id,
            updated_at: this.state.kmsFeedbackDataSelectedEdit.updated_at
        }

        API_REMARK.putDataRemark(kmsFeedbackId, data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        showEditModal: false,
                        showConfirmEditAlert: false,
                        showSuccessEditAlert: true,
                        kmsFeedback: ''
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    showConfirmEditAlert: false,
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleSuccessEditKmsFeedback = () => {
        this.setState({
            showSuccessEditAlert: false,
            pagination: {
                ...this.state.pagination,
                current: 1,
                pageSize: 10,
            },
        }, () => {
            this.getInitiateKmsFeedback();
            this.getListKmsFeedback(this.state.pagination.current, this.state.pagination.pageSize);
        })
    }

    handleDeleteKmsFeedback = () => {
        this.setState({ showConfirmDeleteAlert: false });

        const kmsFeedbackId = this.state.kmsFeedbackDataSelectedDelete.id;
        const data = {
            remark: this.state.kmsFeedbackDataSelectedDelete.remark,
            category: 'KMS_Feedback',
            updated_at: this.state.kmsFeedbackDataSelectedDelete.updated_at
        }
        API_REMARK.deleteDataRemark(kmsFeedbackId, data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({ showSuccessDeleteAlert: true });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleSuccessDeleteKmsFeedback = () => {
        this.setState({
            showSuccessDeleteAlert: false,
            pagination: {
                ...this.state.pagination,
                current: 1,
                pageSize: 10,
            },
        }, () => {
            this.getInitiateKmsFeedback();
            this.getListKmsFeedback(this.state.pagination.current, this.state.pagination.pageSize);
        })
    }

    componentDidMount() {
        this._isMounted = true;

        this.getInitiateKmsFeedback();
        this.getListKmsFeedback(this.state.pagination.current, this.state.pagination.pageSize);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[MASTER_DATA_REMARK_VIEW]} userPermission={this.props.userDetail.permissions}>
                <div className="h-full pb-5">
                    {/* Breadcrumbs */}
                    <BreadCrumbs
                        parentMenu="Master Data"
                        serviceMenu="Remark"
                        title="KMS Feedback"
                    />

                    {/* White Container */}
                    <div className="h-content">
                        {/* Content */}
                        <div className="calculate-layout-blank bg-white border border-gray-300 rounded-lg px-6 py-10 space-y-10 overflow-auto">
                            {/* Menu */}
                            <RemarkMenu />

                            <div className="space-y-4">
                                <div className="flex justify-between items-center flex-row-reverse h-12">
                                    {/*  KMS Feedback Information */}
                                    <div className="flex justify-center items-center relative">
                                        <div id="btninfo" className="cursor-pointer" onMouseEnter={() => this.setState({ showPopupInfo: true })} onMouseLeave={() => this.setState({ showPopupInfo: false })}>
                                            <IconInformationBlue />
                                        </div>
                                        <div className={this.state.showPopupInfo ? "absolute w-96 top-0 right-10 z-10 rounded-lg shadow-box-button p-5 text-sm bg-nexcarewhite2" : "hidden"}>
                                            <div className="italic">
                                                <p className="font-bold">Note :</p>
                                                <p>KMS Feedback digunakan untuk pemilihan alasan ketika melakukan penilaian pada KMS di NexCare Mobile dengan pemilihan Tidak Suka.</p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Add KMS Feedback Button */}
                                    <CheckPermissionComponent permissionConstant={[MASTER_DATA_REMARK_INSERT]} userPermission={this.props.userDetail.permissions}>
                                        <button id="btnaddkmsfeedback" onClick={() => this.setState({ showAddModal: true })} className="flex items-center text-white py-2 px-6 rounded-md bg-nexcaredefault cursor-pointer">
                                            <IconAddTransparent />
                                            <span className="ml-2">KMS Feedback</span>
                                        </button>
                                    </CheckPermissionComponent>
                                </div>

                                {/* Table KMS Feedback */}
                                <div>
                                    <TableNexcare
                                        column={this.state.columns}
                                        dataTable={this.state.listKmsFeedback}
                                        pagination={this.state.pagination}
                                        onPage={this.handleSelectedPage}
                                        onPageSize={this.handleSelectedPageSize}
                                        halfBodyHeight
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Add KMS Feedback Modal */}
                    <div className={this.state.showAddModal ? "block" : "hidden"}>
                        <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                            <div className="border-0 rounded-lg shadow-lg bg-white outline-none focus:outline-none p-10 space-y-4 w-1/4">
                                <p className="text-nexcareblack1 text-center text-3xl font-medium">Tambah KMS Feedback</p>
                                <div>
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Remark <Mandatory /></p>
                                    <textarea
                                        id="tmlkmsfeedbackadd"
                                        className="form-control resize-none"
                                        placeholder="Tulis Remark"
                                        name="kmsFeedback"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningKmsFeedback: false });
                                        }}
                                        minLength="3"
                                        maxLength="100"
                                        autoComplete="off"
                                        value={this.state.kmsFeedback}
                                    />
                                    {this.state.showWarningKmsFeedback && <MandatoryAlert text="Remark tidak boleh kosong!" />}
                                </div>
                                <div className="flex justify-center items-center space-x-5">
                                    <ButtonBorderNexcareDefault id="btncancel" onClick={this.handleCancelButton}>
                                        Batal
                                    </ButtonBorderNexcareDefault>
                                    <ButtonNexcareDefault id="btnaddkmsfeedback" onClick={this.handleConfirmAddKmsFeedback}>
                                        Simpan
                                    </ButtonNexcareDefault>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </div>

                    {/* Edit KMS Feedback Modal */}
                    <div className={this.state.showEditModal ? "block" : "hidden"}>
                        <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                            <div className="border-0 rounded-lg shadow-lg bg-white outline-none focus:outline-none p-10 space-y-4 w-1/4">
                                <p className="text-nexcareblack1 text-center text-3xl font-medium">Ubah KMS Feedback</p>
                                <div>
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Remark <Mandatory /></p>
                                    <textarea
                                        id="tmlkmsfeedbackedit"
                                        className="form-control resize-none"
                                        placeholder="Tulis Remark"
                                        name="kmsFeedback"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningKmsFeedback: false });
                                        }}
                                        minLength="3"
                                        maxLength="100"
                                        autoComplete="off"
                                        value={this.state.kmsFeedback}
                                    />
                                    {this.state.showWarningKmsFeedback && <MandatoryAlert text="Remark tidak boleh kosong!" />}
                                </div>
                                <div className="flex justify-center items-center space-x-5">
                                    <ButtonBorderNexcareDefault id="btncancel" onClick={this.handleCancelButton}>
                                        Batal
                                    </ButtonBorderNexcareDefault>
                                    <ButtonNexcareDefault id="btneditkmsfeedback" onClick={this.handleConfirmEditKmsFeedback}>
                                        Simpan
                                    </ButtonNexcareDefault>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </div>

                    {/* Alert */}
                    <Alert show={this.state.showConfirmAddAlert} button title="Simpan KMS Feedback" desc="Apakah Anda yakin ingin menyimpan data?" close={() => this.setState({ showConfirmAddAlert: false })} submit={this.handleAddKmsFeedback} />
                    <Alert show={this.state.showSuccessAddAlert} icon="success" title="Berhasil" desc="Data berhasil disimpan" close={this.handleSuccessAddKmsFeedback} ok />
                    <Alert show={this.state.showConfirmEditAlert} button title="Simpan KMS Feedback" desc="Apakah Anda yakin ingin mengubah data?" close={() => this.setState({ showConfirmEditAlert: false })} submit={this.handleEditKmsFeedback} />
                    <Alert show={this.state.showSuccessEditAlert} icon="success" title="Berhasil" desc="Data berhasil diubah" close={this.handleSuccessEditKmsFeedback} ok />
                    <Alert show={this.state.showConfirmDeleteAlert} button title="Hapus KMS Feedback" desc="Apakah Anda yakin ingin menghapus data?" close={() => this.setState({ showConfirmDeleteAlert: false, kmsFeedbackDataSelectedDelete: {} })} submit={this.handleDeleteKmsFeedback} />
                    <Alert show={this.state.showSuccessDeleteAlert} icon="success" title="Berhasil" desc="Data berhasil dihapus" close={this.handleSuccessDeleteKmsFeedback} ok />
                    <Alert show={this.state.showErrorAlertResponse} icon="warning" title="Oops, Gagal" desc={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(KMSFeedback);